import type { Session } from '../../types/domain'
import { api, loginRequest } from './client'

export interface ChangePasswordInput {
  old_password: string
  new_password: string
}

export interface UpdateProfileInput {
  name: string
  avatar?: string | null
}

export const authApi = {
  login: (email: string, password: string) => loginRequest(email, password) as Promise<Session>,
  changePassword: (input: ChangePasswordInput) => api.post<{ ok: true }>('/change_password', input),
  updateProfile: (input: UpdateProfileInput) =>
    api.post<{ id: string; name: string; role: string; avatar: string }>('/profile', input),
  forgotPassword: (email: string) => api.post<{ ok: true }>('/forgot-password', { email }),
  resetPassword: (token: string, new_password: string) =>
    api.post<{ ok: true }>('/reset-password', { token, new_password }),
}
